const localization: any = {
  en: {
    'cip-title-header': 'Employee Information',
    'scip-title-header': 'Sales CIP',
    'Employee Info': 'Employee Info',
    Name: 'Name',
    'Highest Support Plan': 'Highest Support Plan',
    Company: 'Company',
    'Email Address': 'Email Address',
    'Renga ID': 'Renga ID',
    "Issue Path": 'Issue Path',
    "Channel": 'Channel',
    Phone: 'Phone',
    Country: 'Country',
    Language: 'Language',
    'Active Subscription Plan': 'Active Subscription Plan',
    'Contextual Info': 'Contextual Info',
    'Original Queue': 'Original Queue',
    'Queue Path': 'Queue Path',
    Website: 'Website',
    'CustomerOne Issue': 'CustomerOne Issue',
    'CustomerOne Sub-Issue': 'CustomerOne Sub-Issue',
    'Bot Intent': 'Bot Intent',
    'Bot SubIntent': 'Bot SubIntent',
    'Return customer': 'Return customer',
    Product: 'Product',
    'Number of Transfers': 'Number of Transfers',
    'Connect URL': 'Connect URL',
    'Call Info': 'Call Info',
    'Conversation Info': 'Conversation Info',
    'Current Queue': 'Current Queue',
    'Start Time': 'Start Time',
    Source: 'Source',
    Device: 'Device',
    Browser: 'Browser',
    OS: 'OS',
    'Chat ID': 'Chat ID',
    'Phone ID': 'Phone ID',
    'Case Number': 'Case Number',
    Origin: 'Origin',
    'Value Add Action': 'Value Add Action',
    offerEligibility: 'Offer Eligibility',
    'Customer Info': 'Customer Info',
    'Customer Search': 'Customer Search',
    'page.search.subtitle': 'Please enter customer information',
    'page.search.placeholder': 'Type here',
    'page.search.email': 'Adobe ID (email address)',
    'page.search.phone': 'Phone Number',
    'page.search.submit': 'Search',
    'page.search.separator': 'or',
    'page.search.goback': 'Go back',
    'page.search.message.notlogged': 'Customer not logged in',
    'page.search.message.smscustomer': 'Inbound customer on SMS',
    'page.search.message.notfound': 'Customer not found',
    'page.customer.title': 'Select a customer',
    'page.customer.button.add': 'Add customer',
    'page.customer.button.change': 'Change customer',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Type',
    'page.customer.table.orgName': 'Org Name',
    'page.customer.table.column1': 'FIRST NAME',
    'page.customer.table.column2': 'LAST NAME',
    'page.customer.table.column3': 'COMPANY',
    'page.customer.table.column4': 'EMAIL ADDRESS',
    'page.customer.table.column5': 'PHONE',
    'page.customer.table.column6': 'COUNTRY',
    'page.customer.table.column7': 'Status',
    'customer.selected.toast': 'Customer has been changed successfully',
    'customer.invalidPhone.toast': 'Please enter correct phone number',
    'Customer Interaction Summary': 'Customer Interaction Summary',
    'Quote / Order Details': 'Quote / Order Details',
    Order: 'Order',
    Quote: 'Quote',
    'page.orderDetails.order.notFound': 'No Order found',
    'page.orderDetails.quote.notFound': 'No Quote found',
    'page.fraud.AccountFraudLock': 'NON-GENUINE SUPPLIER',
    'page.fraud.LegalLock': 'TRUST & SAFETY',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID blocked due to fraudulent activity. Transfer the customer to the Adobe Genuine team.',
    'page.fraud.tooltip.LegalLock': 'Adobe ID blocked due to violation of Adobe’s Terms of Use. Inform customer that they should email TOU-Appeals@adobe.com with their issue.',
    Workflow: 'Workflow',
    'COM-INDIVIDUAL-PURCHASE': 'COM-INDIVIDUAL-PURCHASE',
    'COM-TEAM-PURCHASE': 'COM-TEAM-PURCHASE',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-INDIVIDUAL-PURCHASE',
    'COM-TEAM-UPGRADE': 'COM-TEAM-UPGRADE',
    'cip-or': 'or',
    'loader-fetching-customer-profile': 'Fetching Employee profile...',
    'loader-loading': 'Loading...',
    'thank-you': 'Thank you for your input',
    'thank-you-feedback': 'Thank you for your feedback',
    'offer-rejection-reason': 'What is the reason for rejection?',
    'relay-offer-to-customer': 'Did you relay this offer to the customer',
    'did-customer-accept-offer': 'Did the customer accept the offer',
    'offer-pitch-confirmation': 'Are you sure you would like to send this offer to this customer',
    'customer-offer': 'Customer Offer',
    'Conversation with': 'Conversation with',
    'Links Provided': 'Links Provided',
    'Main customer issue': 'Main customer issue',
    'Conversation Points': 'Conversation points',
    'Current Conversation Summary': 'Current Conversation Summary',
    'Is this helpful?': 'Is this helpful?',
    Feedback: 'Feedback',
    Reason: 'Reason',
    'Why was this not helpful?': 'Why was this not helpful?',
    Send: 'Send',
    Cancel: 'Cancel',
    'customer-asked-for-offer': 'Did customer proactively ask for the offer',
    'Cart Details': 'Cart Details',
    'Commitment': 'Commitment',
    'Term': 'Term',
    'Sentiment Graph': 'Sentiment Graph'
  },
  ja: {
    'cip-title-header': 'お客様情報',
    'scip-title-header': 'セールス CIP',
    'Personal Info': '個人情報',
    Name: '名前',
    'Highest Support Plan': 'サポートプラン',
    Company: '会社情報',
    'Email Address': '電子メールアドレス',
    'Renga ID': 'Renga ID',
    Phone: '電話',
    Country: '国名',
    Language: '言語',
    'Active Subscription Plan': '有効なサブスクリプションプラン',
    'Contextual Info': '状況に応じた情報',
    'Original Queue': 'オリジナルスキル',
    'Queue Path': 'キューパス',
    Website: 'Web サイト',
    'CustomerOne Issue': 'CustomerOne の問題',
    'CustomerOne Sub-Issue': 'CustomerOne の下位の問題',
    'Bot Intent': 'ボットの意図',
    'Bot SubIntent': 'ボットの下位の意図',
    'Return customer': 'Return customer', // Need to be updated
    Product: '製品',
    'Number of Transfers': '転送数',
    'Connect URL': '接続 URL',
    'Conversation Info': '会話情報',
    'Current Queue': '現在のスキル',
    'Start Time': '開始時刻',
    Source: 'ソース',
    Device: 'デバイス',
    Browser: 'ブラウザー',
    OS: 'OS',
    'Chat ID': 'チャット ID',
    'Phone ID': '電話 ID',
    Origin: 'オリジン',
    'Value Add Action': '付加価値アクション',
    offerEligibility: 'オファー資格',
    'Customer Info': 'お客様情報',
    'Customer Search': 'お客様を検索',
    'page.search.subtitle': '顧客情報を入力してください',
    'page.search.placeholder': 'ここに入力',
    'page.search.email': 'Adobe ID (電子メールアドレス)',
    'page.search.phone': '電話番号',
    'page.search.submit': '検索',
    'page.search.separator': '-または-',
    'page.search.goback': '前へ戻る',
    'page.search.message.notlogged': 'お客様はログインしていません',
    'page.search.message.smscustomer': 'SMSでお問い合わせのお客様です',
    'page.search.message.notfound': 'お客様が見つかりません',
    'page.customer.title': 'お客様を選択',
    'page.customer.button.add': 'お客様の新規登録',
    'page.customer.button.change': 'お客様を再選択',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Type',
    'page.customer.table.orgName': 'Org Name',
    'page.customer.table.column1': '名',
    'page.customer.table.column2': '姓',
    'page.customer.table.column3': '会社情報',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': '電話番号',
    'page.customer.table.column6': '組織名',
    'page.customer.table.column7': 'ステータス',
    'customer.selected.toast': 'お客様情報が正常に変更されました',
    'customer.invalidPhone.toast': '正しい電話番号を入力してください',
    'Customer Interaction Summary': 'カスタマーインタラクションの概要',
    'Quote / Order Details': '見積/オーダーの詳細',
    Order: 'オーダー',
    Quote: '見積',
    'page.orderDetails.order.notFound': 'オーダーはありません',
    'page.orderDetails.quote.notFound': '見積はありません',
    'page.fraud.AccountFraudLock': '非正規のサプライヤー',
    'page.fraud.LegalLock': 'TRUST & SAFETY',
    'page.fraud.tooltip.AccountFraudLock': '不正なアクティビティがあったため、IDがブロックされました。お客様を Adobe Genuine チームに転送してください',
    'page.fraud.tooltip.LegalLock': 'アドビの利用条件に違反したため、IDがブロックされました。お客様に、問題の詳細を TOU-Appeals@adobe.com にメールで送信するよう伝えてください。',
    Workflow: 'ワークフロー',
    'COM-INDIVIDUAL-PURCHASE': '商業-個人-購買',
    'COM-TEAM-PURCHASE': '商業-チーム-購買',
    'EDU-INDIVIDUAL-PURCHASE': '教育-個人-購買',
    'COM-TEAM-UPGRADE': '商業-チーム-アップグレー',
    'cip-or': 'または',
    'loader-fetching-customer-profile': 'お客様のプロファイルを取得しています...',
    'loader-loading': '読み込み中...',
    'thank-you': '入力ありがとうございます',
    'thank-you-feedback': 'フィードバックをお寄せいただきありがとうございます',
    'offer-rejection-reason': '拒否の理由は何ですか?',
    'relay-offer-to-customer': 'このオファーをお客様に伝えましたか',
    'did-customer-accept-offer': 'お客様はオファーを受け入れましたか',
    'offer-pitch-confirmation': 'お客様にオファーを送信してもよろしいですか',
    'customer-offer': 'カスタマーオファー',

    'Conversation with': 'との会話',
    'Links Provided': '提供リンク',
    'Main customer issue': 'お客様の主なお問合せ',
    'Conversation Points': '会話のポイント',
    'Current Conversation Summary': '現在の会話の要約',
    'Is this helpful?': 'これは役に立ちましたか',
    Feedback: 'フィードバック',
    Reason: '理由',
    'Why was this not helpful?': '役に立たなかった理由は何ですか?',
    Send: '送信',
    Cancel: 'キャンセル',
    'customer-asked-for-offer': '顧客は積極的にオファーを求めましたか',
    'Cart Details': 'カートの詳細',
    'Commitment': 'コミットメント',
    'Term': '期間',
    'Sentiment Graph': 'Sentiment Graph'
  },
  fr: {
    'cip-title-header': 'Informations sur le consommateur',
    'scip-title-header': 'CIP de vente',
    'Personal Info': 'Informations personnelles',
    Name: 'Nom',
    'Highest Support Plan': 'Formule de support',
    Company: 'entreprise',
    'Email Address': 'Adresse Email',
    'Renga ID': 'Renga ID',
    Phone: 'Téléphone',
    Country: 'Pays',
    Language: 'Langue',
    'Active Subscription Plan': 'Formule d’abonnement active',
    'Contextual Info': 'Informations contextuelles',
    'Original Queue': 'File d’attente d’origine',
    'Queue Path': 'Chemin d’accès de la file d’attente',
    Website: 'Site Web',
    'CustomerOne Issue': 'Problème CustomerOne',
    'CustomerOne Sub-Issue': 'Sous-problème CustomerOne',
    'Bot Intent': 'Intention du robot',
    'Bot SubIntent': 'Sous-intention du robot',
    'Return customer': 'Renvoyer le client',
    Product: 'Produit',
    'Number of Transfers': 'Nombre de transferts',
    'Connect URL': 'Connecter URL',
    'Conversation Info': 'Informations sur la conversation',
    'Current Queue': 'File d’attente en cours',
    'Start Time': 'Heure de début',
    Source: 'Source',
    Device: 'Machine',
    Browser: 'Navigateur',
    OS: 'OS',
    'Chat ID': 'ID de chat',
    'Phone ID': 'ID de téléphone',
    Origin: 'Origine',
    'Value Add Action': 'Action à valeur ajoutée',
    offerEligibility: "Eligibilité à l'offre",
    'Customer Info': 'Informations sur le client',
    'Customer Search': 'Recherche client',
    'page.search.subtitle': 'Veuillez saisir des informations client',
    'page.search.placeholder': 'Saisissez ici',
    'page.search.email': 'Identifiant Adobe (adresse email/ courriel électronique)',
    'page.search.phone': 'Numéro de téléphone',
    'page.search.submit': 'Rechercher',
    'page.search.separator': 'ou',
    'page.search.goback': 'Revenir en arrière ',
    'page.search.message.notlogged': 'Client non connecté',
    'page.search.message.smscustomer': 'Client entrant par SMS',
    'page.search.message.notfound': 'Client introuvable',
    'page.customer.title': 'Sélectionner un client',
    'page.customer.button.add': 'Ajouter un client',
    'page.customer.button.change': 'Changer de client',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Type',
    'page.customer.table.orgName': 'Nom de l’organisation',
    'page.customer.table.column1': 'Prénom',
    'page.customer.table.column2': 'Nom',
    'page.customer.table.column3': 'entreprise',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': 'Téléphone',
    'page.customer.table.column6': 'Pays',
    'page.customer.table.column7': 'Statut',
    'customer.selected.toast': 'Le client a été modifié avec succès',
    'customer.invalidPhone.toast': 'Veuillez saisir un numéro de téléphone correct',
    'Customer Interaction Summary': 'Résumé de l’interaction client',
    'Quote / Order Details': 'Devis / Détails de la commande',
    Order: 'Commande',
    Quote: 'Devis',
    'page.orderDetails.order.notFound': 'Aucune commande détectée',
    'page.orderDetails.quote.notFound': 'Aucun devis détecté',
    'page.fraud.AccountFraudLock': 'FOURNISSEUR NON AUTHENTIQUE',
    'page.fraud.LegalLock': 'CONFIANCE ET SÉCURITÉ',
    'page.fraud.tooltip.AccountFraudLock': 'Identifiant Adobe bloqué en raison d’une activité frauduleuse. Transfert du client à l’équipe Adobe Genuine.',
    'page.fraud.tooltip.LegalLock':
      'Identifiant Adobe bloqué en raison d’une violation des conditions d’utilisation d’Adobe. Informer le client de contacter TOU-Appeals@adobe.com pour ce problème.',
    Workflow: 'Processus',
    'COM-INDIVIDUAL-PURCHASE': 'COM-INDIVIDUEL-ACHAT',
    'COM-TEAM-PURCHASE': 'COM-ENTREPRISE-ACHAT',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-INDIVIDUEL-ACHAT',
    'COM-TEAM-UPGRADE': 'COM-ENTREPRISE-MISE À  NIVEAU',
    'cip-or': 'ou',
    'loader-fetching-customer-profile': 'Recherche des profils client...',
    'loader-loading': 'Chargement...',
    'thank-you': 'Merci pour votre contribution',
    'thank-you-feedback': 'Merci pour vos commentaires',
    'offer-rejection-reason': 'Quelle est la raison du rejet?',
    'relay-offer-to-customer': 'Avez-vous transmis cette offre au client',
    'did-customer-accept-offer': `Est-ce que le client a accepté l'offre`,
    'offer-pitch-confirmation': `Êtes-vous sûr de vouloir envoyer l'offre au client`,
    'customer-offer': 'Offre client',
    'Conversation with': 'Conversation avec',
    'Links Provided': 'Liens fournis',
    'Main customer issue': 'Problème principal du client',
    'Conversation Points': 'Points de conversation',
    'Current Conversation Summary': 'Résumé de la conversation en cours',
    'Is this helpful?': 'Est-ce que cela vous est utile?',
    Feedback: 'Commentaires',
    Reason: 'Raison',
    'Why was this not helpful?': `Pourquoi cela n'a-t-il pas été utile?`,
    Send: 'Envoyer',
    Cancel: 'Annuler',
    'customer-asked-for-offer': `Le client a-t-il demandé l'offre de manière proactive`,
    'Cart Details': 'Détails du panier',
    'Commitment': 'Engagement',
    'Term': 'Terme',
    'Sentiment Graph': 'Sentiment Graph'
  },
  de: {
    'cip-title-header': 'Verbraucherinformationen',
    'scip-title-header': 'CIP für Vertrieb',
    'Personal Info': 'Persönliche Informationen',
    Name: 'Name',
    'Highest Support Plan': 'Support-Plan',
    Company: 'Unternehmen',
    'Email Address': 'E-Mail-Adresse',
    'Renga ID': 'Renga ID',
    Phone: 'Telefon',
    Country: 'Land',
    Language: 'Sprache',
    'Active Subscription Plan': 'Aktives Abonnement',
    'Contextual Info': 'Kontextbezogene Informationen',
    'Original Queue': 'Ursprüngliche Warteschlange',
    'Queue Path': 'Warteschlangenpfad',
    Website: 'Website',
    'CustomerOne Issue': 'CustomerOne - Problemkategorie',
    'CustomerOne Sub-Issue': 'CustomerOne - Problemunterkategorie',
    'Bot Intent': 'Bot-Absicht',
    'Bot SubIntent': 'Bot-Unterabsicht',
    'Return customer': 'Zurückkehrender Kunde',
    Product: 'Produkt',
    'Number of Transfers': 'Anzahl der Übertragungen',
    'Connect URL': 'Connect-URL',
    'Conversation Info': 'Unterhaltungsinformationen',
    'Current Queue': 'Aktuelle Warteschlange',
    'Start Time': 'Startzeit',
    Source: 'Quelle',
    Device: 'Gerät',
    Browser: 'Browser',
    OS: 'OS',
    'Chat ID': 'Chat-ID',
    'Phone ID': 'Telefon-ID',
    Origin: 'Quelle',
    'Value Add Action': 'Aktion Wert hinzufügen',
    offerEligibility: 'Eignung für das Angebot',
    'Customer Info': 'Kundeninfo',
    'Customer Search': 'Kundensuche',
    'page.search.subtitle': 'Bitte geben Sie die Kundeninformationen ein',
    'page.search.placeholder': 'Hier eingeben',
    'page.search.email': 'Adobe ID (E-Mail-Adresse)',
    'page.search.phone': 'Telefonnummer',
    'page.search.submit': 'Suche',
    'page.search.separator': 'oder',
    'page.search.goback': 'Zurück',
    'page.search.message.notlogged': 'Kunde nicht angemeldet',
    'page.search.message.smscustomer': 'Eingehender Kunde per SMS',
    'page.search.message.notfound': 'Kunde nicht gefunden',
    'page.customer.title': 'Einen Kunden auswählen',
    'page.customer.button.add': 'Kunde hinzufügen',
    'page.customer.button.change': 'Kunden ändern',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Typ',
    'page.customer.table.orgName': 'Org.-Name',
    'page.customer.table.column1': 'Vorname',
    'page.customer.table.column2': 'Nachname',
    'page.customer.table.column3': 'Unternehmen',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': 'Telefon',
    'page.customer.table.column6': 'Land',
    'page.customer.table.column7': 'Status',
    'customer.selected.toast': 'Kunde wurde geändert',
    'customer.invalidPhone.toast': 'Bitte geben Sie die korrekte Telefonnummer ein',
    'Customer Interaction Summary': 'Zusammenfassung der Kundeninteraktion',
    'Quote / Order Details': 'Angebot/Bestelldetails',
    Order: 'Bestellung',
    Quote: 'Angebot',
    'page.orderDetails.order.notFound': 'Keine Bestellung gefunden',
    'page.orderDetails.quote.notFound': 'Kein Angebot gefunden',
    'page.fraud.AccountFraudLock': 'NICHT ORIGINALANBIETER',
    'page.fraud.LegalLock': 'VERTRAUEN & SICHERHEIT',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID wegen betrügerischer Aktivitäten gesperrt. Kunden an das Adobe Genuine-Team übertragen.',
    'page.fraud.tooltip.LegalLock':
      'Adobe ID wegen Verstoß gegen die Nutzungsbedingungen von Adobe gesperrt. Kunden informieren, sich mit dem Problem per E-Mail an TOU-Appeals@adobe.com zuwenden.',
    Workflow: 'Arbeitsablauf',
    'COM-INDIVIDUAL-PURCHASE': 'COM-INDIVIDUELLER-KAUF',
    'COM-TEAM-PURCHASE': 'COM-TEAM-KAUF',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-INDIVIDUELLER-KAUF',
    'COM-TEAM-UPGRADE': 'COM-TEAM-UPGRADE',
    'cip-or': 'oder',
    'loader-fetching-customer-profile': 'Kundenprofile werden abgerufen...',
    'loader-loading': 'Wird geladen...',
    'thank-you': 'Danke für Ihre Eingabe',
    'thank-you-feedback': 'Danke für dein Feedback',
    'offer-rejection-reason': 'Was ist der Grund für die Ablehnung?',
    'relay-offer-to-customer': 'Haben Sie dieses Angebot an den Kunden weitergeleitet',
    'did-customer-accept-offer': 'Hat der Kunde das Angebot angenommen',
    'offer-pitch-confirmation': 'Möchten Sie das Angebot wirklich an den Kunden senden',
    'customer-offer': 'Angebot für Kunden',
    'Conversation with': 'Gespräch mit',
    'Links Provided': 'Bereitgestellte Links',
    'Main customer issue': 'Hauptproblem des Kunden',
    'Conversation Points': 'Gesprächspunkte',
    'Current Conversation Summary': 'Zusammenfassung des aktuellen Gesprächs',
    'Is this helpful?': 'Ist das hilfreich?',
    Feedback: 'Rückmeldung',
    Reason: 'Grund',
    'Why was this not helpful?': 'Warum war das nicht hilfreich?',
    Send: 'Senden',
    Cancel: 'Stornieren',
    'customer-asked-for-offer': 'Hat der Kunde proaktiv nach dem Angebot gefragt',
    'Cart Details': 'Einzelheiten zum Einkaufswagen',
    'Commitment': 'Engagement',
    'Term': 'Begriff',
    'Sentiment Graph': 'Sentiment Graph'
  },
  es: {
    'cip-title-header': 'Información del consumidor',
    'scip-title-header': 'CIP de ventas',
    'Personal Info': 'Información personal',
    Name: 'Nombre',
    'Highest Support Plan': 'Plan de soporte',
    Company: 'empresa',
    'Email Address': 'Correo Electrónico',
    'Renga ID': 'Renga ID',
    Phone: 'Teléfono',
    Country: 'País',
    Language: 'Idioma',
    'Active Subscription Plan': 'Plan de suscripción activo',
    'Contextual Info': 'Información contextual',
    'Original Queue': 'Cola original',
    'Queue Path': 'Ruta de la cola',
    Website: 'Sitio web',
    'CustomerOne Issue': 'Problema de CustomerOne',
    'CustomerOne Sub-Issue': 'Problema secundario de CustomerOne',
    'Bot Intent': 'Intención del bot',
    'Bot SubIntent': 'Intención secundaria del bot',
    'Return customer': 'Cliente recurrente',
    Product: 'Producto',
    'Number of Transfers': 'Número de transferencias',
    'Connect URL': 'Conectar URL',
    'Conversation Info': 'Información de conversación',
    'Current Queue': 'Cola actual',
    'Start Time': 'Hora de inicio',
    Source: 'Origen',
    Device: 'Dispositivo',
    Browser: 'Navegador',
    OS: 'OS',
    'Chat ID': 'ID de chat',
    'Phone ID': 'ID de teléfono',
    Origin: 'Origen',
    'Value Add Action': 'Acción de valor añadido',
    offerEligibility: 'Elegibilidad de la oferta',
    'Customer Info': 'Información del cliente',
    'Customer Search': 'Búsqueda de clientes',
    'page.search.subtitle': 'Por favor, introduzca la información del cliente',
    'page.search.placeholder': 'Escriba aquí',
    'page.search.email': 'Adobe ID (correo electrónico)',
    'page.search.phone': 'Número de teléfono',
    'page.search.submit': 'Buscar',
    'page.search.separator': 'o',
    'page.search.goback': 'Volver atrás',
    'page.search.message.notlogged': 'Cliente no conectado',
    'page.search.message.smscustomer': 'Cliente entrante en SMS',
    'page.search.message.notfound': 'Cliente no encontrado',
    'page.customer.title': 'Seleccionar un cliente',
    'page.customer.button.add': 'Añadir cliente',
    'page.customer.button.change': 'Cambiar cliente',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Escribir',
    'page.customer.table.orgName': 'Nombre de la organización',
    'page.customer.table.column1': 'Nombre',
    'page.customer.table.column2': 'Apellidos',
    'page.customer.table.column3': 'empresa',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': 'Teléfono',
    'page.customer.table.column6': 'País',
    'page.customer.table.column7': 'Estado',
    'customer.selected.toast': 'El cliente ha sido cambiado con éxito',
    'customer.invalidPhone.toast': 'Por favor, introduzca el número de teléfono correcto',
    'Customer Interaction Summary': 'Resumen de la interacción con el cliente',
    'Quote / Order Details': 'Detalles del presupuesto/pedido',
    Order: 'Pedido',
    Quote: 'Presupuesto',
    'page.orderDetails.order.notFound': 'No se ha encontrado ningún pedido',
    'page.orderDetails.quote.notFound': 'No se ha encontrado ningún presupuesto',
    'page.fraud.AccountFraudLock': 'PROVEEDOR NO GENUINO',
    'page.fraud.LegalLock': 'CONFIANZA Y SEGURIDAD',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID bloqueado debido a una actividad fraudulenta. Transfiera al cliente al equipo de Adobe Genuino.',
    'page.fraud.tooltip.LegalLock':
      'Adobe ID bloqueado debido a una violación de los términos de uso de Adobe. Informe al cliente de que debe notificar el problema escribiendo a TOU-Appeals@adobe.com.',
    Workflow: 'Flujo de trabajo',
    'COM-INDIVIDUAL-PURCHASE': 'COM-COMPRA-INDIVIDUAL',
    'COM-TEAM-PURCHASE': 'COM-COMPRA-EQUIPO',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-COMPRA-INDIVIDUAL',
    'COM-TEAM-UPGRADE': 'COM-ACTUALIZACIÓN-EQUIPO',
    'cip-or': 'o',
    'loader-fetching-customer-profile': 'Obteniendo perfiles de cliente...',
    'loader-loading': 'Cargando...',
    'thank-you': 'Gracias por tu aporte',
    'thank-you-feedback': 'Gracias por tus comentarios',
    'offer-rejection-reason': '¿Cuál es el motivo del rechazo?',
    'relay-offer-to-customer': '¿Le transmitiste esta oferta al cliente',
    'did-customer-accept-offer': '¿El cliente ha aceptado la oferta',
    'offer-pitch-confirmation': '¿Estás seguro de que quieres enviar la oferta al cliente',
    'customer-offer': 'Oferta para clientes',

    'Conversation with': 'Conversación con',
    'Links Provided': 'Enlaces proporcionados',
    'Main customer issue': 'Principal incidencia del cliente',
    'Conversation Points': 'Tópicos de conversación',
    'Current Conversation Summary': 'Resumen de la conversación actual',
    'Is this helpful?': '¿Esto es útil?',
    Feedback: 'Opinión',
    Reason: 'Motivo',
    'Why was this not helpful?': '¿Por qué no fue útil?',
    Send: 'Enviar',
    Cancel: 'Cancelar',
    'customer-asked-for-offer': `El cliente solicitó la oferta de forma proactiva`,
    'Cart Details': 'Detalles del carrito',
    'Commitment': 'Compromiso',
    'Term': 'Plazo',
    'Sentiment Graph': 'Sentiment Graph'
  },
  it: {
    'cip-title-header': 'Informazioni sul consumatore',
    'scip-title-header': 'Vendite CIP',
    'Personal Info': 'Informazioni personali',
    Name: 'Nome',
    'Highest Support Plan': 'Piano di assistenza',
    Company: 'azienda',
    'Email Address': 'Indirizzo E-Mail',
    'Renga ID': 'Renga ID',
    Phone: 'Telefono',
    Country: 'Paese',
    Language: 'Lingua',
    'Active Subscription Plan': 'Piano di abbonamento attivo',
    'Contextual Info': 'Informazioni contestuali',
    'Original Queue': 'Coda originale',
    'Queue Path': 'Percorso coda',
    Website: 'Sito Web',
    'CustomerOne Issue': 'Problema CustomerOne',
    'CustomerOne Sub-Issue': 'Problema secondario CustomerOne',
    'Bot Intent': 'Finalità bot',
    'Bot SubIntent': 'Finalità secondaria bot',
    'Return customer': 'Cliente abituale',
    Product: 'Prodotto',
    'Number of Transfers': 'Numero di trasferimenti',
    'Connect URL': 'URL di connessione',
    'Conversation Info': 'Informazioni sulla conversazione',
    'Current Queue': 'Coda corrente',
    'Start Time': 'Ora di inizio',
    Source: 'Origine',
    Device: 'Dispositivo',
    Browser: 'Navigatore',
    OS: 'OS',
    'Chat ID': 'ID chat',
    'Phone ID': 'ID telefono',
    Origin: 'Origine',
    'Value Add Action': 'Valore Aggiungi azione',
    offerEligibility: "Idoneità all'offerta",
    'Customer Info': 'Informazioni cliente',
    'Customer Search': 'Ricerca cliente',
    'page.search.subtitle': 'Per favore, inserisci le informazioni sul cliente',
    'page.search.placeholder': 'Digita qui',
    'page.search.email': 'Adobe ID (indirizzo e-mail)',
    'page.search.phone': 'Numero di telefono',
    'page.search.submit': 'Cerca',
    'page.search.separator': 'o',
    'page.search.goback': 'Indietro',
    'page.search.message.notlogged': "Il cliente non ha eseguito l'accesso",
    'page.search.message.smscustomer': 'Clienti in entrata su SMS',
    'page.search.message.notfound': 'Cliente non trovato',
    'page.customer.title': 'Seleziona un cliente',
    'page.customer.button.add': 'Aggiungi cliente',
    'page.customer.button.change': 'Cambia cliente',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Digitare',
    'page.customer.table.orgName': 'Nome organizzazione',
    'page.customer.table.column1': 'Nome',
    'page.customer.table.column2': 'Cognome',
    'page.customer.table.column3': 'azienda',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': 'Telefono',
    'page.customer.table.column6': 'Paese',
    'page.customer.table.column7': 'Stato',
    'customer.selected.toast': 'Cliente modificato correttamente',
    'customer.invalidPhone.toast': 'Per favore, immetti il numero di telefono corretto',
    'Customer Interaction Summary': 'Riepilogo interazione con il cliente',
    'Quote / Order Details': 'Dettagli offerta/ordine',
    Order: 'Ordine',
    Quote: 'Offerta',
    'page.orderDetails.order.notFound': 'Nessun ordine trovato',
    'page.orderDetails.quote.notFound': 'Nessun preventivo trovato',
    'page.fraud.AccountFraudLock': 'FORNITORE NON ORIGINALE',
    'page.fraud.LegalLock': 'FIDUCIA e SICUREZZA',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID bloccato a causa di attività fraudolente. Trasferire il cliente al team Adobe Genuine.',
    'page.fraud.tooltip.LegalLock':
      "Adobe ID bloccato a causa di violazione delle Condizioni d'uso di Adobe. Informare il cliente di inviare un'e-mail a TOU-Appeals@adobe.com descrivendo il problema riscontrato.",
    Workflow: 'Flusso di lavoro',
    'COM-INDIVIDUAL-PURCHASE': 'ACQUISTO-INDIVIDUALE-COM',
    'COM-TEAM-PURCHASE': 'ACQUISTO-TEAM-COM',
    'EDU-INDIVIDUAL-PURCHASE': 'ACQUISTO-INDIVIDUALE-EDU',
    'COM-TEAM-UPGRADE': 'UPGRADE-TEAM-COM',
    'cip-or': 'o',
    'loader-fetching-customer-profile': 'Recupero dei profili cliente in corso...',
    'loader-loading': 'Caricamento...',
    'thank-you': 'Grazie per il tuo contributo',
    'thank-you-feedback': 'Grazie per il tuo feedback',
    'offer-rejection-reason': 'Qual è il motivo del rifiuto?',
    'relay-offer-to-customer': 'Hai inoltrato questa offerta al cliente',
    'did-customer-accept-offer': `Il cliente ha accettato l'offerta`,
    'offer-pitch-confirmation': `Sei sicuro di voler inviare l'offerta al cliente`,
    'customer-offer': 'Offerta per i clienti',

    'Conversation with': 'Conversazione con',
    'Links Provided': 'Collegamenti forniti  /  Link forniti',
    'Main customer issue': 'Problema principale del cliente',
    'Conversation Points': 'Punti di conversazione',
    'Current Conversation Summary': 'Riepilogo della conversazione attuale',
    'Is this helpful?': 'È utile?',
    Feedback: 'Feedback',
    Reason: 'Motivo',
    'Why was this not helpful?': 'Perché non è stato utile?',
    Send: 'Inviare',
    Cancel: 'Annulla',
    'customer-asked-for-offer': `Il cliente ha chiesto l'offerta in modo proattivo`,
    'Cart Details': 'Dettagli del carrello',
    'Commitment': 'Impegno',
    'Term': 'Termine',
    'Sentiment Graph': 'Sentiment Graph'
  },
  'pt-BR': {
    'cip-title-header': 'Informações de Consumidor',
    'scip-title-header': 'CIP de Vendas',
    'Personal Info': 'Informações pessoais',
    Name: 'Nome',
    'Highest Support Plan': 'Plano de suporte',
    Company: 'empresa',
    'Email Address': 'Endereço Eletrônico',
    'Renga ID': 'Renga ID',
    Phone: 'Telefone',
    Country: 'País',
    Language: 'Idioma',
    'Active Subscription Plan': 'Plano de assinatura ativa',
    'Contextual Info': 'Informações contextuais',
    'Original Queue': 'Fila original',
    'Queue Path': 'Caminho de Fila',
    Website: 'Site',
    'CustomerOne Issue': 'Problema CustomerOne',
    'CustomerOne Sub-Issue': 'Sub-problema CustomerOne',
    'Bot Intent': 'Intenção do Robô ',
    'Bot SubIntent': 'Subintenção do Robô',
    'Return customer': 'Cliente habitual',
    Product: 'Produto',
    'Number of Transfers': 'Número de Transferências',
    'Connect URL': 'Conectar URL',
    'Conversation Info': 'Informações de Conversa',
    'Current Queue': 'Fila atual',
    'Start Time': 'Hora de Início',
    Source: 'Origem',
    Device: 'Dispositivo',
    Browser: 'Navegador',
    OS: 'OS',
    'Chat ID': 'ID do chat',
    'Phone ID': 'ID do telefone',
    Origin: 'Origem',
    'Value Add Action': 'Ação de valor agregado',
    offerEligibility: 'Elegibilidade da oferta',
    'Customer Info': 'Informações de cliente',
    'Customer Search': 'Pesquisa de Cliente',
    'page.search.subtitle': 'Por favor digite as informações do cliente',
    'page.search.placeholder': 'Digite aqui',
    'page.search.email': 'Adobe ID (endereço Eletrônico)',
    'page.search.phone': 'Número de telefone',
    'page.search.submit': 'Pesquisar',
    'page.search.separator': 'ou',
    'page.search.goback': 'Voltar',
    'page.search.message.notlogged': 'Cliente não logado',
    'page.search.message.smscustomer': 'Cliente destinatário no SMS',
    'page.search.message.notfound': 'Cliente não Encontrado',
    'page.customer.title': 'Selecione um cliente',
    'page.customer.button.add': 'Adicionar Cliente',
    'page.customer.button.change': 'Alterar cliente',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': 'Digitar',
    'page.customer.table.orgName': 'Nome Org',
    'page.customer.table.column1': 'Nome',
    'page.customer.table.column2': 'Sobrenome',
    'page.customer.table.column3': 'empresa',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': 'Telefone',
    'page.customer.table.column6': 'País',
    'page.customer.table.column7': 'Status',
    'customer.selected.toast': 'O cliente foi modificado com sucesso',
    'customer.invalidPhone.toast': 'Por favor digite o número de telefone correto',
    'Customer Interaction Summary': 'Resumo da interação com o cliente',
    'Quote / Order Details': 'Orçamento/Detalhes do pedido',
    Order: 'Pedido',
    Quote: 'Orçamento',
    'page.orderDetails.order.notFound': 'Nenhum pedido encontrado',
    'page.orderDetails.quote.notFound': 'Nenhum orçamento encontrado',
    'page.fraud.AccountFraudLock': 'FORNECEDOR NÃO GENUINO',
    'page.fraud.LegalLock': 'CONFIANÇA & SEGURANÇA',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID bloqueada devido a atividade fraudulenta. Transferir o cliente para a equipe Adobe Genuina.',
    'page.fraud.tooltip.LegalLock':
      'Adobe ID bloqueado devido a violação dos Termos de Uso da Adobe. Informe o cliente que deve enviar email do problema para TOU-Appeals@adobe.com.',
    Workflow: 'Fluxo de trabalho',
    'COM-INDIVIDUAL-PURCHASE': 'COM-COMPRA-INDIVIDUAL',
    'COM-TEAM-PURCHASE': 'COM-COMPRA-EQUIPE',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-COMPRA-INDIVIDUAL',
    'COM-TEAM-UPGRADE': 'COM-ATUALIZAÇÃO-EQUIPE',
    'cip-or': 'ou',
    'loader-fetching-customer-profile': 'Buscando Perfis de Cliente...',
    'loader-loading': 'Carregando...',
    'thank-you': 'Obrigado por sua contribuição',
    'thank-you-feedback': 'Obrigado pelo seu feedback',
    'offer-rejection-reason': 'Qual é o motivo da rejeição?',
    'relay-offer-to-customer': 'Você retransmitiu essa oferta ao cliente',
    'did-customer-accept-offer': 'O cliente aceitou a oferta',
    'offer-pitch-confirmation': 'Tem certeza de que gostaria de enviar a oferta ao cliente',
    'customer-offer': 'Oferta ao cliente',

    'Conversation with': 'Conversar com',
    'Links Provided': 'Links fornecidos',
    'Main customer issue': 'Problema principal do cliente',
    'Conversation Points': 'Pontos de conversação',
    'Current Conversation Summary': 'Resumo da conversa atual',
    'Is this helpful?': 'Isso é útil?',
    Feedback: 'Feedback',
    Reason: 'Razão',
    'Why was this not helpful?': 'Por que isso não foi útil?',
    Send: 'Enviar',
    Cancel: 'Cancelar',
    'customer-asked-for-offer': `O cliente solicitou proativamente a oferta`,
    'Cart Details': 'Detalhes do carrinho',
    'Commitment': 'Compromisso',
    'Term': 'Prazo',
    'Sentiment Graph': 'Sentiment Graph'
  },
  'zh-TW': {
    'cip-title-header': '消費者資訊',
    'scip-title-header': '銷售 CIP',
    'Personal Info': '個人資訊',
    Name: '姓名',
    'Highest Support Plan': '支援方案',
    Company: '公司',
    'Email Address': '電子郵件地址',
    'Renga ID': 'Renga ID',
    Phone: '電話',
    Country: '國家 / 地區',
    Language: '語言',
    'Active Subscription Plan': '有效的訂閲方案',
    'Contextual Info': '背景資訊',
    'Original Queue': '最初佇列',
    'Queue Path': '佇列路徑',
    Website: '網站',
    'CustomerOne Issue': 'CustomerOne 問題',
    'CustomerOne Sub-Issue': 'CustomerOne 子問題',
    'Bot Intent': '機器人意圖',
    'Bot SubIntent': '機器人子意圖',
    'Return customer': '回頭客',
    Product: '產品',
    'Number of Transfers': '轉移次數',
    'Connect URL': 'Connect URL',
    'Conversation Info': '對話資訊',
    'Current Queue': '目前佇列',
    'Start Time': '開始時間',
    Source: '來源',
    Device: '裝置',
    Browser: '瀏覽器',
    OS: 'OS',
    'Chat ID': '聊天 ID',
    'Phone ID': '電話 ID',
    Origin: '來源',
    'Value Add Action': '增值行動',
    offerEligibility: '優惠資格',
    'Customer Info': '客戶資訊',
    'Customer Search': '客戶搜尋',
    'page.search.subtitle': '請輸入正確客戶資訊',
    'page.search.placeholder': '在此輸入',
    'page.search.email': 'Adobe ID (電子郵件地址)',
    'page.search.phone': '電話號碼',
    'page.search.submit': '搜尋',
    'page.search.separator': '或',
    'page.search.goback': '返回',
    'page.search.message.notlogged': '未登入客戶',
    'page.search.message.smscustomer': '簡訊帶來的入站客戶',
    'page.search.message.notfound': '查無客戶',
    'page.customer.title': '選取客戶',
    'page.customer.button.add': '新增客戶',
    'page.customer.button.change': '變更客戶',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': '輸入',
    'page.customer.table.orgName': '組織名稱',
    'page.customer.table.column1': '名字',
    'page.customer.table.column2': '姓氏',
    'page.customer.table.column3': '公司',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': '電話',
    'page.customer.table.column6': '國家 / 地區',
    'page.customer.table.column7': '狀態',
    'customer.selected.toast': '已成功變更客戶',
    'customer.invalidPhone.toast': '請輸入正確電話號碼',
    'Customer Interaction Summary': '客戶互動摘要',
    'Quote / Order Details': '報價 / 訂單詳細資訊',
    Order: '訂單',
    Quote: '報價',
    'page.orderDetails.order.notFound': '查無訂單',
    'page.orderDetails.quote.notFound': '查無報價',
    'page.fraud.AccountFraudLock': '非正版供應商',
    'page.fraud.LegalLock': '信任與安全',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID 因不正當活動被封鎖。將客戶轉移至 Adobe 正版軟體團隊。',
    'page.fraud.tooltip.LegalLock': 'Adobe ID 因違反 Adobe《使用條款》被封鎖。請客戶傳送電子郵件至 TOU-Appeals@adobe.com，表明他們遇到的問題。',
    Workflow: '工作流程',
    'COM-INDIVIDUAL-PURCHASE': 'COM-INDIVIDUAL-PURCHASE',
    'COM-TEAM-PURCHASE': 'COM-TEAM-PURCHASE',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-INDIVIDUAL-PURCHASE',
    'COM-TEAM-UPGRADE': 'COM-TEAM-UPGRADE',
    'cip-or': '或',
    'loader-fetching-customer-profile': '正在擷取客戶個人資料…',
    'loader-loading': '正在載入...',
    'thank-you': '感謝您的意見',
    'thank-you-feedback': '感謝您的反饋',
    'offer-rejection-reason': '拒絕的原因是什麼?',
    'relay-offer-to-customer': '您是否將此優惠傳遞給客戶',
    'did-customer-accept-offer': '客戶是否接受報價',
    'offer-pitch-confirmation': '您確定要將優惠傳送給客戶嗎',
    'customer-offer': '客戶優惠',

    'Conversation with': '對話',
    'Links Provided': '提供的連結',
    'Main customer issue': '主要客戶問題',
    'Conversation Points': '對話要點',
    'Current Conversation Summary': '當前對話摘要',
    'Is this helpful?': '這有幫助嗎？',
    Feedback: '反饋',
    Reason: '原因',
    'Why was this not helpful?': '為什麼這沒有幫助？',
    Send: '發送',
    Cancel: '取消',
    'customer-asked-for-offer': '客戶是否主動要求報價',
    'Cart Details': '購物車詳情',
    'Commitment': '承諾',
    'Term': '期限',
    'Sentiment Graph': 'Sentiment Graph'
  },
  'zh-CN': {
    'cip-title-header': '消费者信息',
    'scip-title-header': '销售 CIP',
    'Personal Info': '个人信息',
    Name: '姓名',
    'Highest Support Plan': '支持计划',
    Company: '公司',
    'Email Address': '电子邮件地址',
    'Renga ID': 'Renga ID',
    Phone: '电话',
    Country: '国家/地区',
    Language: '语言',
    'Active Subscription Plan': '有效的订阅计划',
    'Contextual Info': '背景信息',
    'Original Queue': '初始队列',
    'Queue Path': '队列路径',
    Website: '网站',
    'CustomerOne Issue': 'CustomerOne 问题',
    'CustomerOne Sub-Issue': 'CustomerOne 子问题',
    'Bot Intent': '机器人意图',
    'Bot SubIntent': '机器人子意图',
    'Return customer': '回头客',
    Product: '产品',
    'Number of Transfers': '转接数量',
    'Connect URL': 'Connect URL',
    'Conversation Info': '对话信息',
    'Current Queue': '当前队列',
    'Start Time': '开始时间',
    Source: '来源',
    Device: '设备',
    Browser: '浏览器',
    OS: 'OS',
    'Chat ID': '聊天 ID',
    'Phone ID': '设备 ID',
    Origin: '来源',
    'Value Add Action': '增值操作',
    offerEligibility: '优惠资格',
    'Customer Info': '客户信息',
    'Customer Search': '客户搜索',
    'page.search.subtitle': '请输入客户信息',
    'page.search.placeholder': '在此键入',
    'page.search.email': 'Adobe ID（电子邮件地址）',
    'page.search.phone': '电话号码',
    'page.search.submit': '搜索',
    'page.search.separator': '或',
    'page.search.goback': '返回',
    'page.search.message.notlogged': '客户未登录',
    'page.search.message.smscustomer': '短信入站客户',
    'page.search.message.notfound': '客户未找到',
    'page.customer.title': '选择客户',
    'page.customer.button.add': '添加客户',
    'page.customer.button.change': '更改客户',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': '键入',
    'page.customer.table.orgName': '组织名称',
    'page.customer.table.column1': '名字',
    'page.customer.table.column2': '姓氏',
    'page.customer.table.column3': '公司',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': '电话',
    'page.customer.table.column6': '国家/地区',
    'page.customer.table.column7': '状态',
    'customer.selected.toast': '客户已成功更改',
    'customer.invalidPhone.toast': '请输入正确的电话号码',
    'Customer Interaction Summary': '客户互动摘要',
    'Quote / Order Details': '报价/订单详情',
    Order: '订单',
    Quote: '报价',
    'page.orderDetails.order.notFound': '没有找到订单',
    'page.orderDetails.quote.notFound': '没有找到报价',
    'page.fraud.AccountFraudLock': '非正版供应商',
    'page.fraud.LegalLock': '信任和安全',
    'page.fraud.tooltip.AccountFraudLock': 'Adobe ID 因存在不正当活动而被封锁。将客户转接给 Adobe 正版团队。',
    'page.fraud.tooltip.LegalLock': 'Adobe ID 因违反 Adobe 使用条款而被封锁。告知客户发送电子邮件至 TOU-Appeals@adobe.com 以反映此问题。',
    Workflow: '工作流',
    'COM-INDIVIDUAL-PURCHASE': 'COM-INDIVIDUAL-PURCHASE',
    'COM-TEAM-PURCHASE': 'COM-TEAM-PURCHASE',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-INDIVIDUAL-PURCHASE',
    'COM-TEAM-UPGRADE': 'COM-TEAM-UPGRADE',
    'cip-or': '或',
    'loader-fetching-customer-profile': '提取客户个人资料...',
    'loader-loading': '正在加载...',
    'thank-you': '感谢您的投入',
    'thank-you-feedback': '感谢您的反馈',
    'offer-rejection-reason': '拒绝的原因是什么?',
    'relay-offer-to-customer': '您是否向客户转达了此报价',
    'did-customer-accept-offer': '客户接受报价了吗',
    'offer-pitch-confirmation': '您确定要向买家发送报价吗',
    'customer-offer': '客户优惠',

    'Conversation with': '与之交谈',
    'Links Provided': '提供的链接',
    'Main customer issue': '主要客户问题',
    'Conversation Points': '对话要点',
    'Current Conversation Summary': '当前对话摘要',
    'Is this helpful?': '这有用吗？',
    Feedback: '反馈',
    Reason: '原因',
    'Why was this not helpful?': '为什么这没有帮助？',
    Send: '发送',
    Cancel: '取消',
    'customer-asked-for-offer': '客户是否主动要求报价',
    'Cart Details': '购物车详情',
    'Commitment': '承诺',
    'Term': '学期',
    'Sentiment Graph': 'Sentiment Graph'
  },
  ko: {
    'cip-title-header': '고객 정보',
    'scip-title-header': '세일즈 CIP',
    'Personal Info': '개인 정보',
    Name: '이름',
    'Highest Support Plan': '지원 플랜',
    Company: '회사',
    'Email Address': '이메일 주소',
    'Renga ID': 'Renga ID',
    Phone: '전화',
    Country: '국가',
    Language: '언어',
    'Active Subscription Plan': '기본 구독 플랜',
    'Contextual Info': '상황별 정보',
    'Original Queue': '최초 대기열',
    'Queue Path': '대기열 경로',
    Website: '웹 사이트',
    'CustomerOne Issue': 'CustomerOne 문제',
    'CustomerOne Sub-Issue': 'CustomerOne 하위 문제',
    'Bot Intent': '봇 의도',
    'Bot SubIntent': '봇 하위 의도',
    'Return customer': '재연락 고객',
    Product: '제품',
    'Number of Transfers': '전송 횟수',
    'Connect URL': 'URL 연결',
    'Conversation Info': '대화 정보',
    'Current Queue': '현재 대기열',
    'Start Time': '시작 시간',
    Source: '소스',
    Device: '장치',
    Browser: '브라우저',
    OS: 'OS',
    'Chat ID': '채팅 ID',
    'Phone ID': '휴대전화 ID',
    Origin: '기준',
    'Value Add Action': '밸류애드 액션',
    offerEligibility: '오퍼 자격',
    'Customer Info': '고객 정보',
    'Customer Search': '고객 검색',
    'page.search.subtitle': '다음 고객 정보를 입력하십시오.',
    'page.search.placeholder': '여기에 입력',
    'page.search.email': 'Adobe ID(이메일 주소)',
    'page.search.phone': '전화 번호',
    'page.search.submit': '검색',
    'page.search.separator': '또는',
    'page.search.goback': '돌아가기',
    'page.search.message.notlogged': '로그인하지 않은 고객',
    'page.search.message.smscustomer': 'SMS로 연락한 고객',
    'page.search.message.notfound': '고객을 찾을 수 없음',
    'page.customer.title': '고객 선택',
    'page.customer.button.add': '고객 추가',
    'page.customer.button.change': '고객 변경',
    'page.customer.status.active': 'Active',
    'page.customer.status.inactive': 'Inactive',
    'page.customer.table.type': '유형',
    'page.customer.table.orgName': '조직 이름',
    'page.customer.table.column1': '성',
    'page.customer.table.column2': '이름',
    'page.customer.table.column3': '회사',
    'page.customer.table.column4': 'Adobe ID',
    'page.customer.table.column5': '전화',
    'page.customer.table.column6': '국가',
    'page.customer.table.column7': '상태',
    'customer.selected.toast': '고객이 성공적으로 변경되었습니다',
    'customer.invalidPhone.toast': '올바른 전화 번호를 입력하십시오',
    'Customer Interaction Summary': '고객 대화 요약',
    'Quote / Order Details': '견적/주문 세부 정보',
    Order: '주문',
    Quote: '견적',
    'page.orderDetails.order.notFound': '주문을 찾을 수 없음',
    'page.orderDetails.quote.notFound': '견적을 찾을 수 없음',
    'page.fraud.AccountFraudLock': '정품이 아닌 공급업체',
    'page.fraud.LegalLock': '신뢰와 안전',
    'page.fraud.tooltip.AccountFraudLock': '사기 활동으로 인해 Adobe ID가 차단되었습니다. 고객을 Adobe Genuine팀으로 전송하십시오.',
    'page.fraud.tooltip.LegalLock':
      'Adobe의 사용 약관 위반으로 인해 Adobe ID가 차단되었습니다. 고객에게 TOU-Appeals@adobe.com으로 발생한 문제에 대해 이메일을 보내라고 안내합니다.',
    Workflow: '워크플로우',
    'COM-INDIVIDUAL-PURCHASE': 'COM-INDIVIDUAL-PURCHASE',
    'COM-TEAM-PURCHASE': 'COM-TEAM-PURCHASE',
    'EDU-INDIVIDUAL-PURCHASE': 'EDU-INDIVIDUAL-PURCHASE',
    'COM-TEAM-UPGRADE': 'COM-TEAM-UPGRADE',
    'cip-or': '또는',
    'loader-fetching-customer-profile': '고객 프로필을 가져오는 중입니다',
    'loader-loading': '로드 중...',
    'thank-you': '의견을 보내 주셔서 감사합니다',
    'thank-you-feedback': '피드백을 주셔서 감사합니다.',
    'offer-rejection-reason': '거절 사유는 무엇입니까?',
    'relay-offer-to-customer': '이 제안을 고객에게 전달하셨나요',
    'did-customer-accept-offer': '고객이 제안을 수락했나요',
    'offer-pitch-confirmation': '정말로 고객에게 오퍼를 보내시겠습니까',
    'customer-offer': '고객 제안',

    'Conversation with': '와의 대화',
    'Links Provided': '제공된 링크',
    'Main customer issue': '고객님의 주요 문의내용',
    'Conversation Points': '대화 포인트',
    'Current Conversation Summary': '현재 대화 요약',
    'Is this helpful?': '도움이 되었나요?',
    Feedback: '피드백',
    Reason: '이유',
    'Why was this not helpful?': '도움이 안된 이유를 알려 주시겠어요?',
    Send: '보내기',
    Cancel: '취소',
    'customer-asked-for-offer': '고객이 사전에 제안을 요청했나요',
    'Cart Details': '카트 세부 정보',
    'Commitment': '헌신',
    'Term': '용어',
    'Sentiment Graph': 'Sentiment Graph'
  },
};

export const NOT_HELPFUL_REASON = {
  en: [
    { id: 1, reason: 'Outdated info' },
    { id: 2, reason: 'Irrelevant/Incorrect info' },
    { id: 3, reason: 'Had to Edit' },
    { id: 4, reason: 'Too Lengthy' },
    { id: 5, reason: 'Robotic' }
  ]
}

export default localization
